"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.interruption.hint': '您可以通过说话来打断代理',
    'conversation.interruption.active': '正在打断代理...',
};
